import { render, staticRenderFns } from "./VaultModal.vue?vue&type=template&id=bf3a94e8&scoped=true&"
import script from "./VaultModal.vue?vue&type=script&lang=ts&"
export * from "./VaultModal.vue?vue&type=script&lang=ts&"
import style0 from "./VaultModal.vue?vue&type=style&index=0&id=bf3a94e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3a94e8",
  null
  
)

export default component.exports